import { render, staticRenderFns } from "./CoDigitalBooks.vue?vue&type=template&id=2fe71e92&scoped=true&"
import script from "./CoDigitalBooks.vue?vue&type=script&lang=js&"
export * from "./CoDigitalBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe71e92",
  null
  
)

export default component.exports